import * as React from 'react';

import { mergeStyles } from '@cian/utils';
import { Checkbox, Tooltip } from '@cian/ui-kit';

import { TOOLTIP_NO_OFFER_TEXT } from '../../../constants';
import { IStationModel } from '../../../store/stations';
import { DEFAULT_STATION_GROUPS, filterSelectedStations, isStationEnabled } from '../../../utils/stations';
import { IStationListProps } from './container';

import * as styles from './StationList.css';

interface IStationGroupProps extends IStationListProps {
  groupIndex: number;

  changeStationGroup(checked: boolean, stations: IStationModel[]): void;
  getAvailableStations(stations: IStationModel[]): IStationModel[];
  onStationValueChange(id: number, name: string, checked: boolean): void;
}

export const StationGroup = ({
  groupedStations,
  groupIndex,
  selectedStations,
  stationData,
  stationDistance,

  changeStationGroup,
  getAvailableStations,
  onStationValueChange,
}: IStationGroupProps) => {
  if (!Number.isFinite(groupIndex)) {
    return null;
  }
  const stations = groupedStations[groupIndex];
  const availableStations = getAvailableStations(stations);
  const groupDisabled = !availableStations.length;
  const groupValue = !groupDisabled && availableStations.every(filterSelectedStations(selectedStations));

  return (
    <div {...mergeStyles(styles['list-group'])} key={groupIndex}>
      <span className={styles['list-checkbox_group']}>
        <Checkbox
          key={groupIndex}
          label={DEFAULT_STATION_GROUPS[groupIndex]}
          disabled={groupDisabled}
          checked={groupValue}
          value={String(groupIndex)}
          onChange={(_e, checked) => changeStationGroup(checked, availableStations)}
        />
      </span>
      <div className={styles['list-stations']}>
        {stations.map(({ id, name }) => {
          const disabled = !isStationEnabled(id, stationData, stationDistance);
          const value = selectedStations.includes(id);
          const checkboxElement = (
            <Checkbox
              label={name}
              checked={value}
              value={String(id)}
              onChange={(_e, checked) => onStationValueChange(id, name, checked)}
              disabled={!value && disabled}
            />
          );

          return (
            <span key={id} className={styles['list-item']}>
              {disabled ? (
                <Tooltip title={TOOLTIP_NO_OFFER_TEXT} placement="right">
                  {checkboxElement}
                </Tooltip>
              ) : (
                checkboxElement
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
};
